<template>
  <section class="view">
    <div class="container intro-section center-page-content">
      <div class="row align-items-center justify-content-center">
        <div class="col text-center">
          <Icon name="grFaceFrown" width="36" class="mb-3"/>
          <h1 class="title mb-2">{{ $t('pages.not_found.friendly_msg') }} {{
              $t('pages.not_found.headline_title')
            }}</h1>
          <h4 class="subtitle">
            {{ $t('pages.not_found.headline_txt') }}
          </h4>
          <router-link :to="{ name: 'homepage' }" class="btn btn-primary mt-4">
            {{ $t('pages.not_found.btn_back') }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo: {
    title: 'Page Not Found',
  }
}
</script>
